<template>
    <div 
        :class="[
            'consent-control flex flex-column flex-content-center flex-unset-align no-select',
            { 'is-checked': isChecked },
            { 'is-inputless': isInputless }
        ]"
        @click="onClickControl"
    >
        <div class="consent-control-label flex">
            <IconCheck />
            <span 
                v-bastards
                class="fs-21" 
                v-text="label"
            />
        </div>
        <div class="consent-control-input text-center">
            <span 
                v-bastards
                class="text-bold fs-18"
                v-text="`${inputLabel}:`"
            />

            <Component 
                v-if="inputComponent" 
                v-model="value"
                :is="inputComponent" 
                :is-required="true"
                ref="inputComponent"
                @input="onInput"
            />
        </div>
    </div>
</template>

<script>
import IconCheck from '@/components/icon/IconCheck'
import InputEmail from '@/components/form/InputEmail'
import InputPhone from '@/components/form/InputPhone'

export default {
    components: {
        IconCheck,
        InputEmail,
        InputPhone
    },

    props: {
        label: {
            type: String,
            required: false,
            default: 'Wyrażam zgodę'
        },
        type: {
            required: true,
            default: 0
        },
        inputLabel: {
            type: String,
            required: false,
            default: ''
        },
        isInputless: {
            type: Boolean,
            required: false,
            default: false
        },
        iconType: {
            type: String,
            required: true
        },
        inputType: {
            type: String,
            required: false,
            validator(value) {
                return value === 'email' || value === 'phone'
            }
        }
    },

    data () {
        return {
            isChecked: false,
            value: ''
        }
    },

    computed: {
        inputComponent() {
            const inputComponentsMap = {
                email: InputEmail,
                phone: InputPhone
            }

            if (!inputComponentsMap.hasOwnProperty(this.inputType)) {
                return null
            }

            return this.inputType
                ? inputComponentsMap[this.inputType]
                : null
        }
    },

    watch: {
        isChecked(value) {
            if (value === true) {
                if (this.$refs.inputComponent) {
                    setTimeout(() => {
                        this.$refs.inputComponent.$el.querySelector('input').focus()
                    }, 300)
                }
            }
            else {
                this.value = ''
            }

            this.updateStoreStatus()
        }
    },

    methods: {
        onClickControl(e) {
            if (e.target.tagName.toUpperCase() === 'INPUT') {
                return
            }
            
            this.isChecked = !this.isChecked
        },

        onInput() {
            this.updateStoreStatus()
        },

        updateStoreStatus() {
            if (this.iconType === 'leaflet') {
                this.$store.dispatch('consentsResolver/setLeafletConsent', this.isChecked ? true : false)
            }
            else {
                const result = this.$store.dispatch('consentsResolver/updatePendingConsent', {
                    type: this.type,
                    value: this.value,
                    isGranted: this.isChecked
                })

                if (!result) {
                    alert("Wystąpił nieoczekiwany błąd! Skontaktuj się z administratorem systemu.")
                }
            }
        },

        validate() {
            return !this.isChecked || this.$refs.inputComponent.validate()
        }
    }
}
</script>

<style lang="scss">
.consent-control {
    @include transition(.250s);
    background-color: $color-bg-darker;
    cursor: pointer;
    position: relative;
    min-height: 190px;

    .is-ie & {
        padding-top: 75px;
        display: block;

        &-label {
            display: block;
        }
    }

    &:before {
        content: '';
        @include position-cover();
        @include transform-origin(0, 0);
        @include transform(scaleX(0));
        @include transition(.250s);
        background-color: $color-secondary;
        opacity: 0;
    }

    &-label {
        @include transition(all .150s ease-in-out .200s);
        position: relative;
        padding: 0 0 0 63px;
        margin: 0 0 0 63px;
        max-width: 245px;

        .icon-check {
            position: absolute;
            left: 0;

            > svg {
                > circle {
                    &.icon-check-front {
                        @include transition(opacity .200s ease-in-out 0s, stroke-dashoffset 0s linear .300s);
                    }
                }
            }
        }
    }

    &-input {
        @include hide();
        @include transition(all .150s ease-in-out 0s);
        position: absolute;
        padding: 0 35px;
        width: 100%;
        bottom: 22px;

        > [class^="input-"] {
            margin-top: 7px;
        }
    }

    &:hover {
        background-color: rgba($color-primary, .1);
    }

    &:hover & {
        &-label {
            .icon-check {
                > svg {
                    > circle {
                        &.icon-check-front {
                            @include transition(opacity .300s ease-in-out 0s, stroke-dashoffset .300s ease-in-out .100s);
                            stroke-dashoffset: 0;
                            opacity: 1;
                        }
                    }
                }
            }
        }
    }

    &:active:not(.is-checked) & {
        &-label {
            .icon-check {
                @include transform(scale(.718));
            }
        }
    }

    &.is-checked {
        &:before {
            @include transform-none();
            opacity: 1;
        }
    }

    &.is-checked & {
        &-label {
            .icon-check {
                > [class^="icon-noun_"] {
                    @include transform-none();
                    opacity: 1;
                }

                > svg {
                    > circle {
                        &.icon-check-bg,
                        &.icon-check-front {
                            stroke: $color-success;
                        }
                    }
                }
            }
        }
    }

    &.is-checked:not(.is-inputless) & {
        &-label {
            @include transform(translateY(-32px));
        }

        &-input {
            @include transition-delay(0.250s);
            @include transform-none();
            @include show();
        }
    }
}
</style>
